import React from 'react'
import { Badge } from '../../../group_leader/components/common'
import { makeT } from '../../../group_leader/helpers/i18n'

const t = makeT('group_leader.event_results.leaderboard')

// Marks a golfer who is out on the course with a card in progress.
const PlayingTag = () => (
  <Badge tone="success" ariaLabel={t('playing_aria')} className="gl-event-results-playing-tag">
    {t('playing_tag')}
  </Badge>
)

export default PlayingTag
